import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import ImmobilisationMineTable from './ImmobilisationMineTable';
import ImmobilisationMineStockTable from './ImmobilisationMineStockTable';
import MainContainer from '../../../components/MainContainer';
import { headerData } from '../../../data/modules/my-validations-header';
import { AntTab, AntTabs } from '../../../components/ant-tab';
import AppBar from "@material-ui/core/AppBar";
import Spacer from "../../../components/Spacer";


import { useState, useEffect, useContext } from "react";
import TextField from "@material-ui/core/TextField";
import {
  Button,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@material-ui/core";
import ValidateRequest from "../../tools/ValidateImmobilisationStepRequest";
import InventoryService from "../../../services/InventoryService";
import Message from "../../tools/Message";
import FilterValidation from "../../../components/FilterValidation";
import filterSubmit from "../../../components/FilterValidation";
import { exportImmobilisationValidationExcel } from "./ImmobilisationValidationExcelExport";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    elevation: 0
  },
  tab1: {
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
      width: "100%"
    }
  },
  antTabCustom: {
    whiteSpace: 'nowrap',
    fontSize: '0.85rem',
    minWidth: 200,
  },
}));

export default function ImmobilisationValidationTab() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [isExporting, setIsExporting] = useState(false);

  const [acceptButton, setAcceptButton] = useState(true);
  const [logistics_manager, setLogistics_manager] = useState([]);
  const [openValidateRequest, setOpenValidateRequest] = useState(false);
  const [message, setMessage] = useState({
      open: false,
      color: 'green',
      messageInfo: '',
  });
  const { open, color, messageInfo } = message;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [form, setForm] = useState({
    name_materiel: "",
    code_immo: "",
    state: "",
    logistics_manager:"",
    status1: "",
    status2: "",
  });
  
  function handleValidateRequest() {
    localStorage.setItem("immoStatusStorage", "CONFIRMED");
    localStorage.setItem("validationByHolderStorage", true);
    console.log('All validated: ',localStorage.getItem("validationByHolderStorage"),localStorage.getItem("immoArrayStorage"));
    if(localStorage.getItem("immoArrayStorage") !== null){
      setOpenValidateRequest(true);
    }
    else{
      alert("Merci de sélectionner au moins un matériel.");
    }
  }
  
  function handleConfirmRequest() {
    localStorage.setItem("immoStatusStorage", "CONFIRMED");
    localStorage.setItem("confirmationByOldHolderStorage", true);
    console.log('All confirmed: ',localStorage.getItem("confirmationByOldHolderStorage"),localStorage.getItem("immoArrayStorage"));
    if(localStorage.getItem("immoArrayStorage") !== null){
      setOpenValidateRequest(true);
    }
    else{
      alert("Merci de sélectionner au moins un matériel.");
    }
  }

  function handleRefusedRequest() {
    localStorage.setItem("declinedByHolderStorage", true);
    console.log('All refused: ',localStorage.getItem("declinedByHolderStorage"),localStorage.getItem("immoArrayStorage"));
    if(localStorage.getItem("immoArrayStorage") !== null){
      setOpenValidateRequest(true);
    }
    else{
      alert("Merci de sélectionner au moins un matériel.");
    }
  }
  
  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  const SetFilter = (name,value)=>{
    if(!value){
      if(localStorage.getItem(name)){
        localStorage.setItem(name,localStorage.getItem(name));
      }
    }
    else{

      localStorage.setItem(name,value);
    }
  }

  const handleSubmit = (e) => {
    window.location.reload();

  };

  const handleExportExcel = async () => {
    if (isExporting) return;

    setIsExporting(true);
    try {
      const result = await exportImmobilisationValidationExcel(value);
      if (result.exported) {
        setMessage({
          open: true,
          color: 'green',
          messageInfo: `${result.rowCount} ligne(s) exportée(s) avec succès.`,
        });
      } else {
        setMessage({
          open: true,
          color: 'darkorange',
          messageInfo: "Aucune donnée à exporter pour cet onglet.",
        });
      }
    } catch (error) {
      console.error("Erreur lors de l'export Excel des immobilisations :", error);
      setMessage({
        open: true,
        color: 'darkred',
        messageInfo: error.message || "Une erreur est survenue pendant l'export Excel.",
      });
    } finally {
      setIsExporting(false);
    }
  };
  const Refresh = (e) => {
    e.preventDefault();
      localStorage.removeItem('name_materiel');
      localStorage.removeItem('code_immo');
      localStorage.removeItem('state');
      localStorage.removeItem('logistics_manager');
      localStorage.removeItem('status1');
      localStorage.removeItem('status2');
      localStorage.setItem('name_materiel',"");
      localStorage.setItem('code_immo',"");
      localStorage.setItem('state',"");
      localStorage.setItem('logistics_manager',"");
      localStorage.setItem('status1',"");
      localStorage.setItem('status2',"");
      
      window.location.reload()
  };

  useEffect(() => {
      var countList = InventoryService.getCountMinePendingImmoHistory().then((result) => {
        if (result && result.status) {
          setAcceptButton(true);
      } else {
        setAcceptButton(false);
      }
    });
      
  }, [value]);

  const handleCloseValidateRequest = (event) => {
    setOpenValidateRequest(false);
  }


  return (
    <>
    <MainContainer {...headerData}>
      <Grid container item xs={12}>
            <Button variant="contained" onClick={Refresh} style={{ fontWeight: 600, backgroundColor:'darkred', color:'white'}}>réinitialiser le filtre</Button><Spacer x={2} />
            <Button
              variant="contained"
              onClick={handleExportExcel}
              disabled={isExporting}
              style={{ fontWeight: 600, backgroundColor: isExporting ? undefined : '#217346', color: 'white' }}
            >
              {isExporting ? 'EXPORT EN COURS...' : 'EXPORTER EN EXCEL'}
            </Button><Spacer x={2} />
            <Button variant="contained" color="primary" onClick={handleSubmit} style={{ fontWeight: 600} }> Filtrer </Button><Spacer x={2} />
      
            <FilterValidation type={2} />
      </Grid>

      <Grid container item xs={12}>
        <AppBar position="static" color="default">
          <AntTabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto" aria-label="scrollable auto tabs example">
            <AntTab disableRipple label="Demandes en attente de ma validation" className={classes.tab1} />
            <AntTab label="Demandes en attente de ma validation pour les immobilisations en stock" />
          </AntTabs>
        </AppBar>
      </Grid>
      <Spacer y={2}/>
      {value == 0 && 
      <Grid item xl={12}>
        <Paper className={classes.paper} variant="outlined">
            <Grid container item xs={12} justifyContent="flex-end" alignItems="left" spacing={1}>
              { acceptButton
                    && (
                      <Button variant="contained" color="primary" onClick={handleValidateRequest} style={{ fontWeight: 600, backgroundColor:"green", color:"#FFFFFF", marginLeft: "auto"  }}  title="En acceptant l'acquisition en tant que nouveau détenteur, les articles sélectionnés seront validés.">
                        TOUS ACCEPTER
                      </Button>
              )}
              <Spacer x={1} />
              {/* { acceptButton
                    && (
                      <Button variant="contained" color="secondary" onClick={handleConfirmRequest} style={{ fontWeight: 600, backgroundColor:"rgb(167, 167, 55)", color:"#FFFFFF"  }}  title="Confirmer l'affectation en tant qu'ancien détenteur, les articles sélectionnés seront validés.">
                        TOUS CONFIRMER
                      </Button>
              )} */}
              <Spacer x={1} />
              { acceptButton
                      && (
                        <Button variant="contained" color="secondary" onClick={handleRefusedRequest}  title="Refuser l'acquisition, les articles sélectionnés seront refusés.">
                          TOUS REFUSER
                        </Button>
              )}
            </Grid>
          <ImmobilisationMineTable />
        </Paper>
      </Grid>}

      
      {value == 1 && 
      <Grid item xl={12}>
        <Paper className={classes.paper} variant="outlined">
          <ImmobilisationMineStockTable />
        </Paper>
      </Grid>}

    </MainContainer>
        
    <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
    
    <ValidateRequest openValidateRequest={openValidateRequest} handleCloseValidateRequest={handleCloseValidateRequest} />
    
    </>
  );
}
